import React, { useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useInjectSaga } from 'utils/injectSaga';
import Routes from './Routes';
import { fetchAuthenticatedUser } from './actions';
import { makeSelectToken } from './selectors';
import saga from './saga';
import Heading from '../../components/Heading/index';
import Topbar from '../../components/Heading/Topbar';
import Footer from '../../components/Footer/Footer';

const key = 'app';

function App() {
  useInjectSaga({ key, saga });

  const dispatch = useDispatch();

  const token = useSelector(makeSelectToken());

  useEffect(() => {
    if (token) {
      dispatch(fetchAuthenticatedUser());
    }
  }, [token, dispatch]);

  return (
    <Fragment>
      {/* <LearningPlatform></LearningPlatform> */}
      <Topbar></Topbar>
      <Heading></Heading>
      <Routes />
      <Footer></Footer>
    </Fragment>
  );
}

export default App;
